import { render, staticRenderFns } from "./SpectrumAddTaskDialog.vue?vue&type=template&id=01169ad4&"
import script from "./SpectrumAddTaskDialog.vue?vue&type=script&lang=js&"
export * from "./SpectrumAddTaskDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports